import { __awaiter } from "tslib";
import { formatOdataQuery } from '../oDataQueryString';
import axios from 'axios';
import { merge } from '@fluentui/react';
/**
 * Request maker for OData infinite queries.
 */
export const queryFunctionGetEntity = ({ oDataQuery, pageLength, pageParam, endpointName, uniqueIdentifier = '', }) => __awaiter(void 0, void 0, void 0, function* () {
    const clientDrivenPaging = pageLength !== undefined;
    // Handle numeric pageParam from client-driven paging
    const queryWithSkip = merge(oDataQuery, {
        skip: clientDrivenPaging ? (pageParam || 0) * pageLength : undefined,
    });
    if (!axios.defaults.baseURL) {
        console.error('NOT YET READY');
        throw new Error('not ready');
    }
    const oDataString = formatOdataQuery(queryWithSkip, uniqueIdentifier, false);
    // Axios response
    const response = yield axios.get(`${endpointName}${oDataString && oDataString}`);
    return response.data;
});
